import React from "react";
import { useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter, pipGetProfile } from "../../../utils/pip";

const ProfileForm = () => {
  const navigate = useNavigate();
  // const { profileDetail } = useSelector((state) => state.authReducer);
  const profileDetail = pipGetProfile();

  return (
    <div class="col-md-8 mx-auto">
      <div class="ct_profile_white_bg">
        <div class="ct_section_title">
          <h2 class="section-title mb-4 text-center">
            <strong>My Profile</strong>
          </h2>
        </div>
        <form
          action="#"
          class="d-flex justify-content-center align-items-center"
          style={{ flexDirection: "column" }}
        >
          <div class="ct_profile_pic">
            <img
              src={
                profileDetail?.google_profile_image ??
                profileDetail?.profile_image ??
                "./images/user_profile.png"
              }
              alt=""
            />

            <h4 class="ct_fs_24 mt-3">{profileDetail?.name ?? ""}</h4>
          </div>
          <div class="ct_profile_info">
            <div class="ct_grid_2 mb-3">
              <p class="mb-0 w-25">Name</p>
              <p class="mb-0">:</p>
              <p class="mb-0">{profileDetail?.name ?? ""}</p>
            </div>
            <div class="ct_grid_2 mb-3">
              <p class="mb-0  w-25">Email</p>
              <p class="mb-0">:</p>
              <p class="mb-0">{profileDetail?.email ?? ""}</p>
            </div>
            <div class="ct_grid_2 mb-3">
              <p class="mb-0  w-25">Role </p>
              <p class="mb-0">:</p>
              <p class="mb-0">{capitalizeFirstLetter(profileDetail?.google_classroom_role) ?? ""}</p>
            </div>
          </div>

          {/* <div class="text-center">
            <a
              href="javascript:void(0)"
              onClick={() => navigate(pageRoutes?.editProfile)}
              class="btn btn-secondary ct_btn_animate mt-4 text-center mx-auto  "
            >
              Edit Profile
            </a>
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default ProfileForm;
